import { FunctionComponent } from 'react';
import { ImageProps } from './types';

export const Image: FunctionComponent<ImageProps> = ({ src, width, height, idAttribute }) => (
  <img src={`/img/${src}`} alt={src} width={width} height={height} data-cy={idAttribute} />
);
